@let val = processedValue();
@if (val) {
  <div class="flex items-center gap-1.5">
    <div
      class="inline-flex w-full max-w-48 items-center overflow-hidden rounded-full border border-green-300 bg-green-100 px-2.5 py-0.5 dark:border-green-500 dark:bg-green-800">
      <div class="text-2xs font-medium text-green-700 dark:text-green-200">
        {{ 'table.cell.boolean.true' | translate }}
      </div>
    </div>
  </div>
} @else {
  <div class="flex items-center gap-1.5">
    <div
      class="inline-flex w-full max-w-48 items-center overflow-hidden rounded-full border border-red-300 bg-red-100 px-2.5 py-0.5 dark:border-red-500 dark:bg-red-800">
      <div class="text-2xs font-medium text-red-700 dark:text-red-200">
        {{ 'table.cell.boolean.false' | translate }}
      </div>
    </div>
  </div>
}
